import Qr_goMarket from "static/Qr_goMarket.png";
import Qr_goPayment from "static/Qr_goPayment.png";

export const deepLinkData = {
  install: {
    url: "https://distancing.onelink.me/DeUR/5kirgjpp",
    qr: Qr_goMarket,
  },
  payment: {
    url: "https://distancing.onelink.me/DeUR/i2640w1c",
    qr: Qr_goPayment,
  },
};

// 복귀 사용자용 "앱 실행/설치하기" OneLink (PromotionAlreadyUsed / PromotionCompleted).
const RESUME_INSTALL_ONELINK = {
  dev: "https://distancing-dev.onelink.me/8jMV/r4cnt02w",
  real: "https://distancing.onelink.me/DeUR/psdc4byj",
};

// 마지막 로그인 수단(authenticateType)을 deep_link_value/sub1 로 실어 보내,
// 앱 로그인 화면에서 해당 소셜 버튼에 "최근 로그인" 라벨이 뜨도록 유도한다.
// 알 수 없는 값이면 파라미터 없이 기본 OneLink 를 반환한다.
export function buildResumeInstallDeepLink(
  isDev: boolean,
  authenticateType?: string
) {
  const base = isDev ? RESUME_INSTALL_ONELINK.dev : RESUME_INSTALL_ONELINK.real;
  const method = authenticateType?.toLowerCase();
  return method === "apple" || method === "google" || method === "kakao"
    ? `${base}?deep_link_value=last_login_method&deep_link_sub1=${method}`
    : base;
}
